
import {removeToken, setToken} from "@/utils/token"
import {getAccountInfo} from "@/api/login";
// import {login, changeAdminPassword, getAdminInfo, updateAdminInfo, currentUser} from "@/api/login";
// 处理路由
// roler:supermanager(超级管理员，暂时没做)/commanager（管理员admin）/storemanager（门店agent）
const state = {
    login: true, // 是否登录
    userInfo: null,//用户信息
    role: "",// 权限相关信息 // admin（admin ）、special（judge）、students（team ）,admin_normal(admin)
    isSupperAdmin:false, // 是否是超级管理员，超级管理员才具有删除和操作的权限
    studentInfoIncomplete:"", // 用户信息是否完整
}
const getters = {
    getLoginState: (state) => state.login,// 获取登录状态
    getUserInfo: (state) => state.userInfo,// 获取用户信息
    getRole: (state) => state.role,// 获取用户信息
    getStudentInfoIncomplete: (state) => state.studentInfoIncomplete,// 获取用户信息是否完整
}
const mutations = {
    // 登录成功
    login: (state, payload) => {
        state.login = payload
    },
    // 用户信息
    userInfo: (state, payload) => {
        state.userInfo = payload

    },
    // 学生信息是否完整
    updateStudentInfoComplateState: (state, payload) => {
        if(!payload.Name || !payload.Level|| !payload.Contact || !payload.Email){
            state.studentInfoIncomplete = true
        }else{
            state.studentInfoIncomplete = false
        }
    },
    // 权限信息，路由菜单
    roleInfo: (state, payload) => {
        // 处理操作,普通管理员不让操作删除权限
        if(payload==="admin"){
            state.isSupperAdmin = true
        }else{
            state.isSupperAdmin = false
        }
        // 处理路由权限
        if(payload==="admin" || payload==="admin_normal"){ // admin超级管理员，admin_normal普通管理员
            state.role = "admin"
        }else if(payload==="judge"){ // 评审专家
            state.role = "special"
        }else if(payload==="team"){// 学生
            state.role = "students"
        }else{
            state.role===""
        }

    },
    loginOut: (state) => {
        // state.login = payload === 'undefined' ? false : !payload
        state.login = false // 登出
        state.auth = ""
        state.userInfo = ""
        state.isSupperAdmin = false
        removeToken() // 消除token
        window.location.reload()
    },
}
const actions = {
    loginOut(context) { // 退出
        context.commit("loginOut", true)
    },
//    获取当前账户信息
    async getUserInfo(context,data){
        const res = await getAccountInfo(data)
        if(res.err_code ===0){
            // enterFinal 是否进入决赛
            context.commit("userInfo", {...res,...res.data} || "") // 更新用户信息
            context.commit("roleInfo", res.role || "") // 更新权限
            if(res.role==="team"){
                context.commit("updateStudentInfoComplateState", res.data || "") // 判断学生信息是否完整
            }
        }
        return Promise.resolve(res)
    }

}
const modules = {}
export default {
    namespaced: true,
    state() {
        return state
    },
    getters,
    mutations,
    actions,
    modules
}

